import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';

class EditApplication extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			catname : '',
			fdate : '',
			todate : '',
			reason : '',
			appstatus : '',
			_message : '',
			alertClass :'',
			posts : [],
			 _redirect : false
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	onBack(e){
		
		this.setState({_redirect : true});
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** submit form **/
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.catname && this.state.fdate && this.state.todate && this.state.reason && this.state.appstatus){
			
			PostData('leave/updateapp',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Application Updated Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("subform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdetails();
		this.getleavecat();
	}
	
	/** get Class **/
	getdetails(){
		
		GetData('leave/getappbyid/'+this.props.match.params.id).then((result) => {
			let res = result;
			if(res){
				this.setState({
					catname : res[0]['category'],
					fdate : res[0]['fromdate'],
					todate : res[0]['todate'],
					reason : res[0]['reason'],
					appstatus : res[0]['appstatus']
				});
			}
		});
	}
	
	/** get Category **/
	getleavecat(){
		
		GetData('leave/getcategory').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
  render() {
	
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/leave/app' />);
	}
	
	 var items = this.state.posts;
	  
	  /** set status select box **/
	this.apstatus = [
		{value : '', name : 'Select'},
		{value : 'Approved', name : 'Approved'},
		{value : 'Rejected', name : 'Rejected'}
	];
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="6">
				<Card>
				  <form action="" method="post" role="form" id="appform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Edit Application</strong>
						<span className="pull-right">
							<Button outline color="primary" onClick={this.onBack}>Back</Button>
						</span>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Leave Category <span className="text-danger">*</span></Label>
							  <select name="catname" onChange={this.onChange} className="form-control" required value={this.state.catname}> 
								<option value="">Select Type</option>
								{
									items.map(function (item) {
										return <option value={item.id }>{item.category}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">From Date <span className="text-danger">*</span></Label>
							  <Input type="date" name="fdate" required onChange={this.onChange} value={this.state.fdate} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">To Date <span className="text-danger">*</span></Label>
							  <Input type="date" name="todate" required onChange={this.onChange} value={this.state.todate} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Reason <span className="text-danger">*</span></Label>
							  <Input type="textarea" name="reason" required onChange={this.onChange} rows="5" value={this.state.reason} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Status <span className="text-danger">*</span></Label>
							  <select name="appstatus" className="form-control" onChange={this.onChange} required value={this.state.appstatus}>
								{this.apstatus.map((e, key) => {
									return <option key={key} value={e.value}>{e.name}</option>;
								})}	
							  </select>
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default EditApplication;


// WEBPACK FOOTER //
// ./src/leave/Application/EditApplication.js